<div class="header">
  <h1
    class="header-text"
    [ngClass]="{
      'changed-label':
        changes.entityAttributes.includes(jobseekerEnum.WorkExperience) &&
        isEdited
    }"
  >
    {{ 'label.WorkExperience' | translate }}
  </h1>
</div>
<div class="experience-container">
  <span
    [ngClass]="{
      'changed-label':
        isEdited &&
        changes.entityAttributes.includes(jobseekerEnum.IsWorkExperienceFilled)
    }"
    class="work-experience-filled"
    >{{ 'label.IsWorkExperienceFilled' | translate }}:
    {{
      isWorkExperienceFilled
        ? ('label.Yes' | translate)
        : ('label.No' | translate)
    }}</span
  >
  <span class="employment-duration">{{
    totalWorkExperienceInMonths | monthToYears
  }}</span>
  <div
    class="work-experience"
    *ngFor="let experience of workExperience"
    [ngClass]="{
      'changed-label':
        checkAddedAndModifiedExperience(experience.experienceId) && isEdited
    }"
  >
    <div class="experience-info">
      <div class="experience-headers">
        <span class="employment-period">{{
          experience.dateFromYear +
            ' ' +
            (experience.dateFromMonth !== null
              ? (experience.dateFromMonth | numberToMonth)
              : '') +
            ' - ' +
            (!experience.isCurrent
              ? experience.dateToYear +
                ' ' +
                (experience.dateToMonth !== null
                  ? (experience.dateToMonth | numberToMonth)
                  : '')
              : ('label.Present' | translate))
        }}</span>
        <span class="position-title">{{ experience.positionTitle }}</span>
        <div class="work-experience-fields">
          <div class="experience-field">
            <span class="experience-field-label"
              >{{ 'label.SeniorityLevel' | translate }}:</span
            >
            <span class="experience-field-value">{{
              experience.seniorityLevelName
            }}</span>
          </div>
          <div class="experience-field">
            <span class="experience-field-label"
              >{{ 'label.EmploymentForm' | translate }}:</span
            >
            <span class="experience-field-value">{{
              experience.employmentFormName
            }}</span>
          </div>
          <div class="experience-field">
            <span class="experience-field-label"
              >{{ 'label.EmploymentType' | translate }}:</span
            >
            <span class="experience-field-value">{{
              experience.employmentFormTypeName
            }}</span>
          </div>
          <div class="experience-field">
            <span class="experience-field-label"
              >{{ 'label.Schedule' | translate }}:</span
            >
            <span class="experience-field-value">{{
              experience.workScheduleName
            }}</span>
          </div>
        </div>
        <div class="locations" *ngIf="experience?.extendedLocations.length">
          <svg-icon src="assets/img/location.svg"></svg-icon>
          <span
            *ngFor="
              let location of experience?.extendedLocations;
              let last = last
            "
          >
            {{ last ? location + '.' : location + ', ' }}
          </span>
        </div>

        <span class="employer">{{ experience.employer }}</span>
        <span class="description">{{ experience.description }}</span>
      </div>
      <div class="reset-button">
        <app-reject-dialog
          *ngIf="
            checkAddedAndModifiedExperience(experience.experienceId) && isEdited
          "
          [id]="experience.experienceId"
          (setDictionary)="reject($event)"
        ></app-reject-dialog>
      </div>
    </div>
    <div class="specializations">
      <span class="specialization-label"
        >{{ 'label.Specialization' | translate }}:
      </span>
      <div *ngFor="let specialization of experience.specializations">
        <span class="specialization-name">{{ specialization.name }} > </span>
        <span
          class="subspecialization-name"
          *ngFor="
            let subspecialization of specialization.children;
            let sublast = last
          "
          >{{
            sublast
              ? subspecialization.name + '; '
              : subspecialization.name + ', '
          }}</span
        >
      </div>
    </div>

    <div class="industries">
      <span class="industry-label"
        >{{ 'label.IndustryField' | translate }}:
      </span>
      <div *ngFor="let industry of experience.industries">
        <span class="industry-name">{{ industry.name }} > </span>
        <span
          class="subindustry-name"
          *ngFor="let subindustry of industry.children; let sublast = last"
          >{{
            sublast ? subindustry.name + '; ' : subindustry.name + ', '
          }}</span
        >
      </div>
    </div>

    <a
      *ngIf="experience.filename"
      [href]="experience.filename"
      class="attachment"
      target="_blank"
    >
      <svg-icon src="assets/img/attachment.svg"></svg-icon>
      <span style="font-weight: 500; color: #819dcd"
        >{{ 'label.Attachment' | translate }}
      </span>
    </a>
  </div>
  <div
    *ngIf="
      isEdited &&
      changes.jobseekerWorkExperienceChanges?.removedWorkExperiences?.length &&
      changes.jobseekerWorkExperienceChanges?.removedWorkExperiences?.length > 0
    "
    class="deleted-experiences"
  >
    <div
      class="work-experience deleted-label"
      *ngFor="
        let experience of changes.jobseekerWorkExperienceChanges
          .removedWorkExperiences
      "
    >
      <span class="employment-period">{{
        experience.dateFromYear +
          ' ' +
          (experience.dateFromMonth !== null
            ? (experience.dateFromMonth | numberToMonth)
            : '') +
          ' - ' +
          (!experience.isCurrent
            ? experience.dateToYear +
              ' ' +
              (experience.dateToMonth !== null
                ? (experience.dateToMonth | numberToMonth)
                : '')
            : ('label.Present' | translate))
      }}</span>
      <span class="position-title">{{ experience.positionTitle }}</span>
      <div class="work-experience-fields">
        <div class="experience-field">
          <span class="experience-field-label"
            >{{ 'label.SeniorityLevel' | translate }}:</span
          >
          <span class="experience-field-value">{{
            experience.seniorityLevelName
          }}</span>
        </div>
        <div class="experience-field">
          <span class="experience-field-label"
            >{{ 'label.EmploymentForm' | translate }}:</span
          >
          <span class="experience-field-value">{{
            experience.employmentFormName
          }}</span>
        </div>
        <div class="experience-field">
          <span class="experience-field-label"
            >{{ 'label.EmploymentType' | translate }}:</span
          >
          <span class="experience-field-value">{{
            experience.employmentFormTypeName
          }}</span>
        </div>
        <div class="experience-field">
          <span class="experience-field-label"
            >{{ 'label.WorkSchedule' | translate }}:</span
          >
          <span class="experience-field-value">{{
            experience.workScheduleName
          }}</span>
        </div>
      </div>
      <div class="locations" *ngIf="experience?.extendedLocations.length">
        <svg-icon src="assets/img/location.svg"></svg-icon>
        <span
          *ngFor="
            let location of experience?.extendedLocations;
            let last = last
          "
        >
          {{ last ? location + '.' : location + ', ' }}
        </span>
      </div>
      <span class="employer">{{ experience.employer }}</span>
      <span class="description">{{ experience.description }}</span>
      <div class="specializations">
        <span class="specialization-label"
          >{{ 'label.Specialization' | translate }}:
        </span>
        <div *ngFor="let specialization of experience.specializations">
          <span class="specialization-name">{{ specialization.name }} > </span>
          <span
            class="subspecialization-name"
            *ngFor="
              let subspecialization of specialization.children;
              let sublast = last
            "
            >{{
              sublast
                ? subspecialization.name + '; '
                : subspecialization.name + ', '
            }}</span
          >
        </div>
      </div>

      <div class="industries">
        <span class="industry-label"
          >{{ 'label.IndustryField' | translate }}:
        </span>
        <div *ngFor="let industry of experience.industries">
          <span class="industry-name">{{ industry.name }} > </span>
          <span
            class="subindustry-name"
            *ngFor="let subindustry of industry.children; let sublast = last"
            >{{
              sublast ? subindustry.name + '; ' : subindustry.name + ', '
            }}</span
          >
        </div>
      </div>

      <a
        *ngIf="experience?.attachment?.filename"
        [href]="experience.attachment.filename"
        class="attachment"
        target="_blank"
      >
        <svg-icon src="assets/img/attachment.svg"></svg-icon>
        <span style="font-weight: 500; color: #819dcd"
          >{{ 'label.Attachment' | translate }}
        </span>
      </a>
    </div>
  </div>
</div>
